import styled from 'styled-components';

export const FormItem = styled.div`
  margin: 0px 0px 20px 0px;
`;
